<template>
  <div class="container u-p1">
    <router-view></router-view>
  </div>
</template>

<script>
import store from './_store'

export default {
  name: 'CheckoutModule',
  components: {},
  created() {
    const STORE_KEY = '$_checkout'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  mounted() {
   
  },
  metaInfo() {
    return {
      title: 'Checkout',
      meta: [{name: 'description', content: 'Kaufen Sie schnell und unkompliziert Ihren gewünschten Gutschein!'}],
    }
  },
}
</script>

<style lang="scss">
.steps {
  margin-bottom: 1rem;
}

.checkout-cart {
  position: sticky;
  top: 5rem;
}

.checkout-finished {
  opacity: 0;
  //transform: translateY(5em);
  position: absolute;
  top: 0;
  width: 100%;
}

@media screen and(max-width:480px) {
  .checkout-steps {
    .step-title {
      font-size: 0.9rem !important;
    }
  }
}
</style>
